import template from "./account-activity-hsa-transaction-payment-details.html"

ko.components.register('account-activity-hsa-transaction-payment-details', {
    template: template,
    viewModel: {
        createViewModel: function (params, componentInfo, widgetInfo) {
            return new PaymentDetails(params, widgetInfo);
        }
    }
});

export class PaymentDetails {
    constructor(params, widgetInfo) {
        let model = params.model;

        this.total = model.FullAmount;
        this.checkNumber = model.CheckNumber;
        this.denialReason = model.DenialReason;
    }
}